<script setup lang="ts">
import { computed } from "vue";
import UnexpectedEventFileType from '@/types/UnexpectedEventFile'

const props = defineProps<{
  file: UnexpectedEventFileType
}>();

const originalFileName = computed(() => {
  return props.file.originalFileName
})

const fileExtension = computed(() => {
  const parts = originalFileName.value.split('.');
  return parts[parts.length - 1];
})

</script>

<template>
  <div class="unexpected-event-show-registered-file">
    <template v-if="fileExtension != 'pdf'">
      <img :src="file?.fileBlob ?? ''" style="width: 100%;">
    </template>
    <template v-else>
      <v-file-input
        :disabled="true"
        :label="originalFileName"
      />
    </template>
  </div>
</template>

<style>
.unexpected-event-show-registered-file label {
  display: block;
  opacity: 0.7;
}
.unexpected-event-show-registered-file .v-field__outline__notch {
  width: inherit;
}
.unexpected-event-show-registered-file .v-field--disabled {
  opacity: 1;
}
</style>
